define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var urlUtil = require('util/url.util');

    var knownURLParameters = Object.freeze({
        CAT: 'cat',
        TOKEN: 'token',
        NATIVE: 'native',
        KRAKEN: 'kraken',
        CONSOLE: 'console',
        BACK_URL: 'back_url',
        HIDE_CHAT: 'hideChat',
        PROMOCODE: 'promocode',
        CLIENTTYPE: 'clienttype',
        CLIENT_TYPE: 'clientType',
        HIDE_HEADER: 'hideHeader',
        HIDE_FOOTER: 'hideFooter',
        JS_FAST_LOAD: 'js_fast_load',
        CLIENTCHANNEL: 'clientchannel',
        ERROR_MESSAGE: 'error_message',
        CLIENT_CHANNEL: 'clientChannel',
        BRIDGE_SUPPORT: 'bridgeSupport',
        AFTER_LOGIN_URL: 'afterLoginUrl',
        CLIENT_PLATFORM: 'clientPlatform',
        SUCCESS_MESSAGE: 'success_message',
        DISABLE_MESSAGE_SUBSCRIPTIONS: 'disableMessageSubscriptions',
    });

    urlUtil.removeUnknownParams = function(url) {
        var params = this.getURLParams(url);
        var leftoverParams = {};

        _.each(params, (value, key) => {
            if (_.values(knownURLParameters).indexOf(key) !== -1) {
                leftoverParams[key] = value;
            }
        });

        url = this.cleanQueryString(url);

        return this.addQueryParameters(url, leftoverParams);
    };

    urlUtil.cleanQueryString = function(href) {
        var [pathname] = href.split('?');

        return pathname;
    };

    urlUtil.addQueryParameters = function(url, parameters) {
        var [cleanUrl, query = ''] = url.split('?');
        var pairs = _.pairs(parameters);
        var serialized = _.map(pairs, ([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');

        if (serialized) {
            query += `${query ? '&' : ''}${serialized}`;
        }

        return `${cleanUrl}${query ? '?' : ''}${query}`;
    };

    module.exports = urlUtil;
});